module.exports = __webpack_public_path__ + "static/sketches-desktop-8f984028ea274c70efdf876c7983f09f.png";